'use client';

import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
import React from 'react';

type AppSettings = {
  displayOverlay?: boolean;
  isNavBarVisible?: boolean;
};

export const appSettingsVar = makeVar<AppSettings>({
  displayOverlay: false,
  isNavBarVisible: true,
});

export const logoRef = React.createRef<HTMLAnchorElement>();

export const useAppSettings = () => {
  const appSettings = useReactiveVar(appSettingsVar);
  return appSettings;
};

export const useUpdateAppSettings = () => {
  const appSettings = useReactiveVar(appSettingsVar);

  return (newAppSettings: Partial<AppSettings>) => {
    appSettingsVar({
      ...appSettings,
      ...newAppSettings,
    });
  };
};
